import type { GenericObject } from '@makemydeal/dr-platform-types';
import { PaymentScheduleTypes } from '@makemydeal/dr-platform-types';
import type { ContractFormType } from '@makemydeal/dr-dash-types';
import { RESIDUAL_FIELD_LABELS } from './mileageCostOptions/constants';

export const ACCESSORIES = 'Accessories';
export const ACCESSORY_FALLBACK_LABEL = 'Accessory';
export const ACQUISITION_FEE_ABBR = 'Acq Fee';
export const ACQUISITION_FEE = 'Acquisition Fee';
export const ACQUISITION_FEE_OPTION_LABEL = 'Upfront?';
export const ACQUISITION_FEE_OPTION_LABEL_INTERSTATE = 'Upfront';
export const ADJUSTED_CAP_COST = 'Adjusted Cap Cost';
export const ADD_ONS = 'Add-ons';
export const ADJUSTED_RESIDUAL_ID = 'adj-residual-id';
export const ADJUSTED_RESIDUAL_LABEL = 'Adj Residual';
export const ADJUSTED_RESIDUAL_VALUE = 'Adj Residual Value';
export const ADJUSTED_RESIDUAL_GROUPID = 'base-residual-group';
export const ADJUSTED_RESIDUAL_VALUE_TESTID = 'adj-residual-value';
export const ADJUSTED_RESIDUAL_GROUP_TESTID = 'adj-residual-group';
export const ADJUSTED_RESIDUAL_DOLLAR_TESTID = 'adj-residual-dollar';
export const ADJUSTED_RESIDUAL_PERCENT_TESTID = 'adj-residual-percent';
export const ADDS_TO_CAP_COST = 'Adds to Cap Cost';
export const ADVANCE_FLAT_TAX = 'Advanced Flat Tax';
export const ADVANCE_SALES_AND_USE_TAX = 'Sales and Use Tax';
export const AMOUNT_FINANCED = 'Amount Financed';
export const APR = 'APR';
export const ALLOWANCE = 'Allowance';
export const BALLOON_PAYMENT = 'Balloon Payment';
export const BALLOON_TERM_TYPE = 'Balloon Term Type';
export const BALLOON_PAYMENT_REQUIRED_ERROR = 'Balloon Payment is required';
export const BASE_RESIDUAL_ID = 'base-residual-id';
export const BASE_RESIDUAL_LABEL = 'Base Residual';
export const RESIDUAL_LABEL = RESIDUAL_FIELD_LABELS.RESIDUAL;
export const BASE_RESIDUAL_PERCENT = 'Base Residual %';
export const BASE_RESIDUAL_DOLLAR = 'Base Residual $';
export const BASE_RESIDUAL_VALUE = 'Base Residual Value';
export const BASE_RESIDUAL_GROUPID = 'base-residual-group';
export const BASE_RESIDUAL_VALUE_TESTID = 'base-residual-value';
export const BASE_RESIDUAL_GROUP_TESTID = 'base-residual-group';
export const BASE_RESIDUAL_DOLLAR_TESTID = 'base-residual-dollar';
export const BASE_RESIDUAL_PERCENT_TESTID = 'base-residual-percent';
export const BASE_MO_PAYMENT = 'Base Mo. Payment';
export const BUY_RATE = 'Buy Rate';
export const CALCULATED_COLUMN_BADGE_LABEL = 'No Program';
export const CALCULATED_COLUMN_ICON_COLOR = '#d26217';
export const CALCULATED_COLUMN_BADGE_BG_COLOR = '#ffbd93';
export const CALCULATED_COLUMN_TOOLTIP = "The lender program doesn't support this deal structure.";
export const CALCULATED_PAYMENTS_DISCLAIMER =
    'Payments are not calculated based on a lender program. All payments are based on the same protection products, accessories and conditional rebates.';
export const CAP_COST_REDUCTION = 'Cap Cost Reduction';
export const CAP_COST_REDUCTION_TAX = 'Cap Reduction Tax';
export const CAP_COST = 'Cap Cost';
export const CAPITALIZED_TAXES = 'Capitalized Taxes';
export const CASH = 'Cash';
export const CASH_DOWN = 'Cash Down';
export const CASH_DUE_TODAY = 'Cash Due Today';
export const CASH_RECEIVED = 'Cash Received';
export const COUNTS_TOWARD_TOTAL_CASH_DOWN = 'Counts toward total Cash Down';
export const CASH_FROM_CUSTOMER = 'Cash from Customer';
export const DUE_AT_SIGNING = 'Due at Signing';
export const DEAL_REVIEW_AND_SUBMISSION_DIALOG_HEADER = 'Go To Deal Review & Submission Screen?';
export const DEAL_REVIEW_AND_SUBMISSION_DIALOG_PROMPT =
    'Clicking "Yes" will send you to the Deal Review & Submission Screen. Are you sure you want to continue?';
export const CASH_PURCHASE_PRICE = 'Cash Purchase Price';
export const CASH_TERMS = 'Cash Terms';
export const CUSTOMER_DETAILS = 'Customer Details';
export const CUSTOM_MILEAGE_LABEL = 'Annual Miles';
export const CUSTOM_MILEAGE_TESTID = 'Custom Miles Per Year';
export const CUSTOM_MILEAGE_ERROR = 'Enter a value in range 1-';
export const CUSTOM_MILEAGE_MAX_LENGTH = 1e5 - 1;
export const CREDIT_DECISION_LENDER_NAME = 'Lender';
export const CREDIT_DECISION_CONTRACTING_LENDER_NAME = 'Contracting Lender';
export const CREDIT_DECISION_LENDER_NAME_FIELD = 'CreditDecisionLenderNameField';
export const LENDER_ADDRESS_ERROR_ALERT_TITLE = "Couldn't load the lender address";
export const LENDER_ADDRESS_ERROR_ALERT_BODY_PREFIX = 'Open ';
export const LENDER_ADDRESS_ERROR_ALERT_BODY_SUFFIX = ' to review the address and complete any required updates.';
export const LENDER_ADDRESS_SECTION_LABEL = 'Lender Address';
export const LENDER_ADDRESS = 'Street Address';
export const LENDER_ADDRESS_LINE_2 = 'Street Address 2';
export const LENDER_CITY = 'City';
export const LENDER_STATE = 'State';
export const LENDER_ZIP = 'Zip';
export const LENDER_PHONE = 'Phone Number';
export const CREDIT_DECISION_STATUS = 'Lender Decision Status';
export const CREDIT_DECISION_TOGGLE = 'Official Credit Decision';
export const CREDIT_SCORE = 'Credit Score';
export const MIN_DAYS_TO_FIRST_PAYMENT = 30;
export const MAX_DAYS_TO_FIRST_PAYMENT = 365;
export const DEALER = 'Dealer';
export const DEALER_CASH = 'Dealer Cash';
export const DEALER_FEES = 'Dealer Fees';
export const DEBOUNCE_TIMER = 2000;
export const DEPRECIATION = 'Total Depreciation';
export const DISCOUNT = 'Discount';
export const DEALER_DISCOUNTS = 'Discounts';
export const DMV = 'DMV';
export const DOC_FEE = 'Doc Fee';
export const DOC_FEES = 'Doc Fees';
export const DRAWER_DURATION = 400;
export const OUT_OF_POCKET = 'Out of Pocket';
export const EASY_CARE_PRO_5_100 = 'Easy Care Pro 5/100';
export const EFFECTIVE_RESIDUAL_PERCENT = 'Effective Residual %';
export const EQUITY_ALLOCATION_ORDER = 'Equity Allocation Order';
export const EST_PAYMENT = 'Est. Payment';
export const EXCESS_MILEAGE_CHARGE = '$/Mi';
export const EXCESS_MILEAGE_PLACEHOLDER = '20';
export const EXISTING_MILEAGE = 'Existing Mileage';
export const EXISTING_MILEAGE_PERCENT = 'Existing Mileage %';
export const EXPECTED_ANNUAL_MILES = 'Exp Miles';
export const EXPECTED_ANNUAL_MILES_PLACEHOLDER = '20,000';
export const FEES = 'Fees';
export const FEE_FALLBACK_LABEL = 'Fee';
export const FINANCE_REDUCTIONS = 'Finance Reductions';
export const FINANCE_TERM = 'Finance Term';
export const FINANCING_TERMS = 'Financing Terms';
export const FIRST_PAYMENT_ABBR = '1st Payment';
export const GAP_INSURANCE = 'Gap Insurance';
export const GAP_REMOVED_ALERT_TITLE = 'GAP Removed';
export const GAP_REMOVED_ALERT_MESSAGE =
    'This deal was switched to cash, so GAP was removed. GAP is only available for financed deals.';
export const GENERIC_LAST_FIELD_CHANGED_ERROR = 'Adjustment did not return a valid payment.';
export const GOV_FEES = 'Gov. Fees';
export const GOVERNMENT_FEES = 'Government Fees';
export const GROSS_CAP_COST = 'Gross Cap Cost';
export const HEADER_HEIGHT = 96;
export const INCENTIVES_TOTAL_OVERRIDE = 'Total Incentives';
export const KS_PLATES = 'KS Plates';
export const KS_TRANSFER = 'KS Transfer';
export const LEASE = 'Lease';
export const LEASE_TERM = 'Lease Term';
export const LEASING_TERMS = 'Leasing Terms';
export const LENDER_FEES = 'Lender Fees';
export const LENGTH_OF_LOAN = 'Length of Loan';
export const LX_PACKAGE_CASH_REBATE = 'LX Package Cash Rebate';
export const MAX_RESIDUALIZED_MSRP = 'MRM';
export const MEMORIAL_DAY_BONUS_CASH = 'Memorial Day Bonus Cash';
export const NO_VALID_PAYMENT_EXIST = 'No valid payments available. Adjust terms or try again later.';
export const MILES_LABEL = 'Miles';
export const MILES_PER_YEAR = 'Annual Miles';
export const MILES_PER_YEAR_PERCENT = 'Annual Miles %';
export const MILITARY_REBATE = 'Military Rebate';
export const MONEY_FACTOR = 'MF';
export const APR_PERCENTAGE = '%';
export const MONEY_FACTOR_TYPE = 'MoneyFactor';
export const MONTHLY_PAYMENT = 'Monthly Payment';
export const MO_PAYMENT = 'Mo. Payment';
export const MO_USE_TAX = 'Mo. Use Tax';
export const MO_USE_TAX_NAME = 'mut';
export const MO_USE_TAXES = 'Mo. Use Taxes';
export const MSRP = 'MSRP';
export const NEGATIVE_TRADE_EQUITY = 'Negative Trade Equity';
export const NET_SELLING_PRICE = 'Net Selling Price';
export const NET_TRADE = 'Net Trade';
export const MULTI_NET_TRADE = 'Net Trades';
export const NET_CASH_PAYOUT = 'Net Cash Payout';
export const NOT_AVAILABLE = 'N/A';
export const NOT_AVAILABLE_DASH = '--';
export const PAYOFF = 'Payoff';
export const PRIOR_BALANCE = 'Prior Balance';
export const PROFIT_DETAILS = 'Profit Details';
export const PROTECTION = 'Protection';
export const PROTECTION_PRODUCTS = 'Protection Products';
export const PAYMENT_FREQUENCY = 'Payment Frequency';
export const PAYMENT_FREQUENCY_DROPDOWN = 'Payment Frequency DropDown';
export const PAYMENT_GRID = 'Payment Grid';
export const PAYMENT_GRID_REQUIRES_VEHICLE = 'Select a vehicle to use the payment grid.';
export const PRICE = 'Price';
export const RADIO_BUTTON_LIST = 'radio-button-list';
export const RADIO_BUTTON_LIST_LABEL = 'Type';
export const RATE = 'Sell Rate';
export const RATE_TYPE = 'Rate Type';
export const RATING_DISPLAY_NAME = 'Rating';
export const RATING_INPUT = 'rating-input';
export const REBATES = 'Rebates';
export const REDUCTIONS = 'Reductions';
export const RENT_CHARGED = 'Mo. Rent Charged';
export const RETAIL_PRICE = 'Retail Price';
export const RUNNING_BOARDS = 'Running Boards';
export const SAFEGUARD_THEFT_PROTECTION = 'Safeguard Theft Protection';
export const SOLD_DATE_REQUIRED_ERROR = 'Sold date is required';
export const SECURITY_DEPOSIT = 'Security Deposit';
export const SELF_REPORTED_CREDIT_RATING = 'Self Reported Credit Rating';
export const SELF_REPORTED_CREDIT_RATING_FIELD = 'SelfReportedCreditRatingField';
export const TIER = 'Tier';
export const RATING = 'Rating';
export const SELL_RATE = 'Sell Rate';
export const SELLING_PRICE = 'Selling Price';
export const TARGET_OUT_OF_POCKET = 'Target Out of Pocket';
export const CASH_AMOUNT = 'Cash Amount';
export const CASH_AMOUNT_PAID = 'Cash Amount Paid';
export const TAXES = 'Taxes';
export const TERM = 'Term';
export const TAX_CAP_COST_RED = 'Tax on Cap Cost Red.';
export const TEMP_TAG = 'Temp Tag';
export const TOTAL_ADD_ONS = 'Total Add-ons';
export const TOTAL_AMOUNT_DUE = 'Tot. Amt. Due';
export const TOTAL_AMOUNT_DUE_FINANCE = 'Amt. Financed';
export const TOTAL_BASE_MO_PAYMENTS = 'Tot. Mo. Payments';
export const TOTAL_CAP_REDUCTION = 'Total Cap Reduction';
export const TOTAL_CONDITIONAL_INCENTIVES = 'Total Conditional Incentives';
export const TOTAL_DUE_AT_SIGNING = 'Tot. Due at Signing';
export const TOTAL_FEES = 'Total Fees';
export const TOTAL_FINANCED = 'Total Financed';
export const TOTAL_INTEREST = 'Total Interest';
export const TOTAL_MANUFACTURER_INCENTIVES = 'Total Manufacturer Incentives';
export const TOTAL_OF_PAYMENTS = 'Tot. Amt you will pay';
export const TOTAL_OF_PAYMENTS_TOOLTIP =
    'The total the customer pays over the life of the deal: all scheduled payments plus up-front amounts (down payment, trade-in, cash).';
export const TOTAL_OF_PAYMENTS_INFO_LABEL = 'More info about Tot. Amt you will pay';
export const TOTAL_PROTECTION = 'Total Protection';
export const TOTAL_RESIDUAL = 'Total Residual';
export const TOTAL_TAX = 'Total Tax';
export const TOTAL_TAXES = 'Total Taxes';
export const TRADE_ALLOWANCE = 'Trade Allowance';
export const TRADE_ACV = 'Trade ACV';
export const TRADE_IN = 'Trade-in';
export const TRADE_IN_MAKE = 'Make';
export const TRADE_IN_MODEL = 'Model';
export const TRADE_IN_TRIM = 'Trim';
export const TRADE_IN_EXTERIOR_COLOR = 'Exterior Color';
export const TRADE_IN_CONDITION = 'Condition';
export const TRADE_IN_YEAR = 'Year';
export const TRADE_OFF = 'Trade Payoff';
export const UPFRONT_ADDONS = 'Upfront Add-ons';
export const UPFRONTS_CAPITALIZED = 'Upfronts Capitalized';
export const UPFRONT_FEES = 'Upfront Fees';
export const UPFRONT_TAXES = 'Upfront Taxes';
export const WINDOW_TINT = 'Window Tint';
export const ZERO_DOLLARS = '$0.00';
export const DOLLAR_SIGN = '$';
export const PERCENT_SIGN = '%';
export const PRIMARY_TAXES = 'Primary Taxes';
export const ADDL_TAXES = 'Additional Taxes';
export const SHARE_URL_OPTION_LABEL = 'Share URL';
export const SHARE_URL_INPUT_LABEL = 'Share URL';
export const COPY_URL_BUTTON_TEXT = 'Copy';
export const COPY_AND_CONTINUE_BUTTON_TEXT = 'Copy and Continue';
export const SHARE_MESSAGE_PLACEHOLDER = 'Include a message about this offer';
export const SHOPPER_EMAIL_INPUT_LABEL = 'Shopper Email Address';
export const DEALER_SUPPORT_REQUEST_FORM = 'https://www.dealer.com/support/requestform/';
export const SALE = 'Sale';
export const APPROVED = 'Approved';
export const SOLD = 'Sold';
export const SALE_DATE = 'Sale Date';
export const SECOND_PAYMENT_DATE = '2nd Payment Date';
export const CONTRACT_SIGNED = 'Contract Signed';
export const SIGNED = 'Signed';
export const DELIVERED = 'Delivered';
export const DELIVERY_DATE = 'Delivery Date';
export const DATE_FORMAT = 'MM/dd/yyyy';
export const MARKUP = 'Markup';
export const STOCK_NUMBER_USED_ERROR_MSG = 'Stock # already in use. Please enter another.';
export const STOCK_NUMBER_USER_PERMISSIONS_ERROR_MSG = 'User needs permissions to the inventory search to edit stock number.';
export const STOCK_NUMBER_DEFAULT_ERROR_MSG = 'Something went wrong. Please try again later.';
export const PAYMENT = 'Payment';
export const TOTAL_BASE_PAYMENT = 'Total Base Payment';
export const PAYMENT_DEPRECIATION = 'Depreciation';
export const PAYMENT_RENT_CHARGE = 'Rent Charge';
export const TOTAL_ADJUSTED_RESIDUAL = 'Adjusted Residual';
export const ADJUSTED_RESIDUAL_PERCENT = 'Adjusted Residual %';
export const ADJUSTED_RESIDUAL_DOLLAR = 'Adjusted Residual $';
export const RESIDUALIZED_ACCESSORIES = 'Residualized Accessories';
export const FIRST_MONTHLY_PAYMENT = '1st Monthly Payment';
export const REGISTRATION_FEE = 'Registration Fee';
export const DUE_AT_SIGNING_PAID_BY = 'Due at Signing Paid By';
export const NET_TRADE_IN_ALLOWANCE = 'Net Trade-in Allowance';
export const NET_TRADE_IN_EQUITY = 'Net Trade-in Equity';
export const REBATES_AND_NONCASH_CREDITS = 'Rebates and Noncash Credits';
export const AMOUNT_PAID_BY_CUSTOMER = 'Amount Paid by Customer';
export const ADDITIONAL_CAPITALIZED_COST = 'Additional Capitalized Cost';
export const AMOUNT_PAID_BY_DEALER = 'Amount Paid by Dealer';
export const CASH_DUE_FROM_CUSTOMER = 'Cash Due from Customer';
export const INSUFFICIENT_FUNDS = 'Insufficient Funds (INSF)';
export const ADJUSTED_SELLING_PRICE = 'Adjusted Selling Price';
export const FLEX_BUY_PERCENT_LABEL = 'Flex Buy %';
export const AVERAGE_MONTHLY_PAYMENT_LABEL = 'Avg. Monthly Payment';
export const COMPARABLE_MONTH_LABEL = 'Comparable {currentTerm} month';
export const FIRST_PAYMENTS_PERIOD = 'First {currentTerm} Payments';
export const NEXT_PAYMENTS_PERIOD = 'Next {currentTerm} Payments';
export const CONTRACT_ALERT_TITLE = 'Unable to Generate Contract';
export const CONTRACT_ALERT_TITLE_READY_TO_GENERATE = 'Ready to Generate Contract';
export const CONTRACT_DETAILS_NEED_ATTENTION = 'details needs attention.';
export type RESIDUAL_TYPE = 'baseResidual' | 'adjustedResidual';
export const CONTRACT_ALERT_MESSAGE =
    'The contract cannot be generated at this time. Please address the following issues before proceeding:';
export const CONTRACT_READY_TO_GENERATE_MESSAGE = 'All errors have been resolved. Click "Regenerate Contract" to proceed.';
export const VEHICLE_VALUE_MISMATCH_MESSAGE =
    "This contract can't be sent to the lender because the vehicle value doesn't match the approved amount. " +
    'The lender approved {approvedAmount}, but the deal shows {vehicleValue}.';
export const VEHICLE_VALUE_MISMATCH_ACTION_PREFIX = 'Update the Invoice value in the';
export const VEHICLE_VALUE_MISMATCH_ACTION_SUFFIX = 'section so it matches the approval.';
export const VEHICLE_DETAILS_LINK_TEXT = 'Vehicle Details';
export const SKEW_DELIMETER = '-';
export const SUMMARY_ACCORDION_ID = 'deal-summary-item-accordion';
export const DEFAULT_EXPANDABLE_ID = 'main';
export const DEFAULT_EXPANDABLE_STATUS = false;
export const DAS_SUCCESS_MESSAGE = 'Changes have been successfully applied.';

export const DEAL_PULSE = 'Deal Pulse';
export const OFFERING_PRICE = 'Offering Price';
export const DOWN_PAYMENT = 'Down Payment';
export const MONTHLY_PAYMENT_LABEL = 'Monthly Payment';

export enum Action {
    CONTINUE_IN_DESKING,
    SEND_TO_ECOMMERCE
}

export enum DealLifeCycleStatus {
    IN_PROGRESS = 'InProgress',
    LOST = 'Lost',
    SOLD = 'Sold'
}

export const UPDATED_DEAL_BANNER_LABELS: GenericObject<string> = {
    creditApplication: 'Credit App',
    documentUpload: 'Document Upload',
    incentives: 'Incentives',
    testDrive: 'Test Drive',
    tradeIn: 'Trade',
    vehicleProtectionProducts: 'Vehicle Protection',
    vehicleReservation: 'Reservations'
};

// Viewport modes
export const MOBILE = 'mobile';
export const TABLET = 'tablet';
export const DESKTOP = 'desktop';

export const MAX_ACTIVITY_CONTAINER_WIDTH_OLD = '1360px';
export const MAX_ACTIVITY_CONTAINER_WIDTH_NEW = '1900px';
export const SLIDEOUT_FULL_WIDTH_BREAKPOINT = '775px';
export const SHARE_TO_SALES_VIEW_HEADER = 'Share to Sales View';
export const CUSTOMER_RANGE_TITLE = 'Customer Range';
export const KBB_VEHICLE_TOOLTIP = "Range shown is for customer's last evaluated vehicle on KBB.com";
export const CUSTOMER_SAW_ON = 'Customer saw on';
export const TRADE_IN_RANGE_TITLE = 'Trade-In Range';

export const WHOLESALE_BOOK_SOURCE_OPTIONS = [
    { label: 'Black Book', value: 'BB' },
    { label: 'Galves', value: 'GALVES' },
    { label: 'KBB', value: 'KBB' },
    { label: 'JD Power', value: 'NADA' },
    { label: 'Other', value: 'OTHER' }
];

export const EQUITY_ALLOCATION_METHOD_OPTIONS = [
    { label: 'None', value: 'None' },
    { label: 'Cash', value: 'Cash' },
    { label: 'Cash, Rebate', value: 'CashRebate' },
    { label: 'Cash, Rebate, Trade', value: 'CashRebateTrade' },
    { label: 'Cash, Trade', value: 'CashTrade' },
    { label: 'Cash, Trade, Rebate', value: 'CashTradeRebate' },
    { label: 'Rebate', value: 'Rebate' },
    { label: 'Rebate, Cash', value: 'RebateCash' },
    { label: 'Rebate, Cash, Trade', value: 'RebateCashTrade' },
    { label: 'Rebate, Trade', value: 'RebateTrade' },
    { label: 'Rebate, Trade, Cash', value: 'RebateTradeCash' },
    { label: 'Trade', value: 'Trade' },
    { label: 'Trade, Cash', value: 'TradeCash' },
    { label: 'Trade, Cash, Rebate', value: 'TradeCashRebate' },
    { label: 'Trade, Rebate', value: 'TradeRebate' },
    { label: 'Trade, Rebate, Cash', value: 'TradeRebateCash' }
];

export const FIRST_PAYMENT_DAY = 'First Payment Date';

export const RESERVE_SECTION_LABEL = 'Reserve Information';
export const RESERVE_SPLIT = 'Reserve Split';
export const RESERVE_SPLIT_CLEARED_BY_LENDER_CHANGE = "Manual reserve split cleared. The new lender's split now applies.";
export const RESERVE_GROSS_LABEL = 'Gross Reserve';
export const RESERVE_RATE_RESERVE_LABEL = 'Rate Reserve';
export const RESERVE_EMPTY_VALUE = '--';
export const DAYS_TO_FIRST_PAYMENT = 'Days to First Payment';
export const DAYS_TO_FIRST_PAYMENT_ABBREVIATED = 'Days to 1st Payment';

export const VERSION_CREATED_BY_TO_APP_DISPLAY_NAME = {
    DarwinFI: 'Darwin'
} as Record<string, string>;

// Application-level config.
// States not listed here show the ARB/NARB selector instead of a fixed value.
export const FIXED_CONTRACT_FORM_TYPE_BY_STATE: Record<string, ContractFormType> = {
    NV: 'NARB',
    AR: 'NARB',
    HI: 'ARB'
};

export const CREDIT_APPLICATION = 'creditApplication';
export const SOURCE_CUSTOMER = 'Customer';
export const SOURCE_DARWIN = 'Darwin';

// Common Consumer updates show a generic, source-agnostic banner (US2091980) — dealers should not
// see the internal "Common Consumer" name they don't recognize.
export const COMMON_CONSUMER_BANNER_TITLE = 'Updates to this deal';
export const COMMON_CONSUMER_BANNER_MESSAGE = 'Customer information on this deal was updated, which may affect the payment.';
export const CREDIT_APP_UPDATED_BANNER_TITLE = 'Credit Application Updated';
export const CREDIT_APP_UPDATED_BANNER_MESSAGE = 'The credit application has been updated.';

export const INPUT_INVALID_ERROR_MESSAGE = 'Invalid';
export const PAYMENT_GRID_REQUIRED_INFO_MESSAGE = 'Required Info.';
export const PAYMENT_GRID_REQUIRED_INFO_COLOR = '#b3500f';
export const SELL_RATE_REQUIRED_ERROR = 'Sell Rate is required';

export const DEAL_SUMMARY_DETAILS = 'Details';
export const DEAL_SUMMARY_DETAILS_EXPAND_ID = 'deal-summary-item-details';
export const EXPANDABLE_ROOT = 'expandable-root';

export const CREDIT_APP_COMPLETED_BADGE_LABEL = 'Credit App Completed';
export const CASH_ORDER_COMPLETED_BADGE_LABEL = 'Cash Order Completed';
export const CREDIT_APP_ATTACHED_BADGE_LABEL = 'Credit App Attached';
export const CASH_ORDER_ATTACHED_BADGE_LABEL = 'Cash Order Attached';
export const DECISION_AVAILABLE_BADGE_LABEL = 'Decision Available';

export const C3BaseUrls = {
    NonProd: 'https://nonprod.ecommerce.app.coxautoinc.com',
    PreProd: 'https://preprod.ecommerce.app.coxautoinc.com',
    Prod: 'https://ecommerce.app.coxautoinc.com',
    Sandbox: 'https://sandbox.ecommerce.app.coxautoinc.com'
};

const ONE_PAY = 'One Pay';
export const PAYMENT_FREQUENCY_OPTIONS: { value: string; label: string }[] = [
    { value: PaymentScheduleTypes.OnePayLease, label: ONE_PAY },
    { value: PaymentScheduleTypes.Monthly, label: PaymentScheduleTypes.Monthly }
];

export const FS_SYNC_FAILURE_BANNER_TITLE = "This deal didn't sync to F&I";
export const FS_SYNC_FAILURE_CORRECTION_LINE = 'Please correct the following. Saving your changes will sync to F&I:';
export const FS_SYNC_FAILURE_ACKNOWLEDGEMENT = 'Okay, Got It';
export const FS_SYNC_FAILURE_CONFIGURATION_BODY = 'Please contact support.';
export const FS_SYNC_FAILURE_SUPPORT_BODY = 'Please contact your administrator or Support.';
export const FS_SYNC_FAILURE_MISSING_BUYER_TITLE = "This deal couldn't sync to F&I because it has no buyer";
export const FS_SYNC_FAILURE_INCOMPLETE_BUSINESS_SIGNER_TITLE =
    "This deal couldn't sync to F&I because the business signer's name is missing or incomplete";
export const FS_SYNC_FAILURE_ADMIN_OR_SUPPORT_BODY = 'Please contact your admin or support.';
export const FS_SYNC_FAILURE_AIO_INTERNAL_ERROR_TITLE = "This deal couldn't sync to F&I because of a system error";
export const FS_SYNC_FAILURE_TRANSIENT_RETRYING = 'Syncing to F&I';
export const FS_SYNC_FAILURE_TRANSIENT_RETRYING_BODY = 'No action needed.';
export const FS_SYNC_FAILURE_TRANSIENT_EXHAUSTED = "This deal didn't sync — F&I couldn't be reached";
export const FS_SYNC_FAILURE_TRANSIENT_EXHAUSTED_BODY = 'Save the deal to retry.';
export const FS_SYNC_FAILURE_UNCLASSIFIED_LINE = "Some details couldn't be sent to F&I — review the deal in Manager View.";
export const FS_SYNC_FAILURE_UNCLASSIFIED_BODY = 'Please contact support if the issue persists.';
export const FS_SYNC_FAILURE_ROLLUP_LINE = 'Review these details.';
export const FS_SYNC_FAILURE_FEES_CATCHALL_ALONE_LINE = 'One or more fee amounts are outside the allowed range.';
export const FS_SYNC_FAILURE_FEES_CATCHALL_ALONGSIDE_LINE = 'Other fee amounts are also outside the allowed range.';

/**
 * Shown when opening a Lease payment grid moves the deal onto an auto-selected program. Deliberately
 * does not name the Auto Select Program checkbox: the control is hidden under
 * `enableExplicitLenderP1`, and on Flex Buy it was already hidden before that, but the switch it
 * describes still happens. Shared so the two components that render this alert cannot drift apart.
 */
export const LEASE_PAYMENT_GRID_PROGRAM_DISCLAIMER = 'A lender program was selected automatically to display the Payment Grid.';
